import request from './Request';
import { getCompanyId, getCompanyName, getPureWhitelabel, getShowcase } from './Amalgam';

export const sendSMS = (phoneNumber) =>
  request({
    method: 'POST',
    url: '/api/sms/generate-otp',
    params: {
      phoneNumber,
      pureWhitelabel: getPureWhitelabel(),
      companyName: getCompanyName(),
      companyId: getCompanyId(),
      service: 'TWILIO'
    }
  });

export const validateCode = (phoneNumber, code) =>
  request({
    method: 'POST',
    url: '/api/sms/validate-otp',
    params: { phoneNumber, code }
  });

export const shouldVerifyOTP = () => !!getShowcase().verifyOTP;
